import { Card, Layout, Page, BlockStack, Text, InlineStack, ButtonGroup, Button, Bleed, Divider, Grid, InlineError } from '@shopify/polaris';
import React, { useState } from 'react';
import { ListIcon, StepIcon } from '../../../../Asests/svgIcon/icon';
import { PhoneMajor } from '@shopify/polaris-icons';
import Beauty from '../../../../Asests/Images/Beauty blog.png';
import BulkEdit from '../../../../Asests/Images/bulk-edit.png';
import ProductSection from '../../../../Asests/Images/product-section.png';
import './Styles/style.css';
import { DI, DIProps } from '../../../../Core';
import { appBridgeRedirect } from '../../Panel/index';
import { useTranslation } from 'react-i18next';

interface props extends DIProps {
    planIsActive: () => void;
    upgradePlan: () => void;
}

const PricingDetail = (props: props) => {
    const { t } = useTranslation();
    const [continueWithImport, setContinueWithImport] = useState<boolean>(true);
    const [loader, setLoader] = useState<boolean>(false);

    const choosePlan = () => {
        setLoader(true);
        props.di.GET('plan/plan/choose', { plan_id: JSON.parse(props.di.globalState.get('plan') ?? "")?.plan_id }).then((data: any) => {
            setLoader(false)
            if (data?.hasOwnProperty('can_proceed_import') && !data?.can_proceed_import) {
                setContinueWithImport(false)
            }
            if (data.success) {
                if (data?.data?.confirmation_url) {
                    let tempUrl = data?.data?.confirmation_url;
                    props.di.globalState.removeLocalStorage(`is_plan_active`)
                    if (process.env.REACT_APP_PROD === "1") {
                        appBridgeRedirect(tempUrl, props);
                    } else window.open(tempUrl)
                }
                else {
                    props.di.globalState.removeLocalStorage(`is_plan_active`)
                    props.planIsActive();
                }
                if (JSON.parse(props.di.globalState.get('plan') ?? "")?.plan_name == 'Free') {
                    props.success(t(data?.message))
                }
                if (JSON.parse(props.di.globalState.get('plan') ?? "")?.plan_name == 'Trial') {
                    props.success(t(data?.message))
                }
            } else {
                props.error(t(data?.message));
            }
        })
    }

    return (
        <Page
            title={t("The way ahead..")}
            backAction={{ content: 'Pricing', onAction: () => props.upgradePlan() }}
        >
            <Card padding="500" roundedAbove='sm'>
                <BlockStack gap="1000">
                    <Layout>
                        <Layout.Section>
                            <BlockStack gap="400">
                                <Text variant="headingXl" as="h3" fontWeight='bold'>
                                    {t("Catalog Expansion: Upgrade your plan to enjoy uninterrupted services")}
                                </Text>
                                <Text variant="headingMd" as="h6" tone='subdued' fontWeight='medium'>
                                    {t("We're excited to see your catalog expanding with more than 10K Products. To continue using the app and ensure smooth sync between Shopify and Amazon, you need to upgrade your plan. However, You can select to prioritize and sync up to 10,000 Products with limited access. For uninterrupted service and to sync all your products seamlessly, upgrade your plan today.")}
                                </Text>
                                <BlockStack gap='500'>
                                    <BlockStack gap='200'>
                                        <Text variant="headingMd" as="h6" tone='subdued' fontWeight='medium'>
                                            {t("Follow the 3 steps")} ({t("explained in detail below")}) :
                                        </Text>
                                        <BlockStack gap="100">
                                            <InlineStack gap="300" blockAlign='center'>
                                                <ListIcon />
                                                <Text variant="headingMd" as="h6" tone='subdued' fontWeight='medium'>
                                                    {t("Navigate to Products page on Shopify")}
                                                </Text>
                                            </InlineStack>
                                            <InlineStack gap="300" blockAlign='center'>
                                                <ListIcon />
                                                <Text variant="headingMd" as="h6" tone='subdued' fontWeight='medium'>
                                                    {t("Enable or Disable the CedCommerce Amazon Channel application")}
                                                </Text>
                                            </InlineStack>
                                            <InlineStack gap="300" blockAlign='center'>
                                                <ListIcon />
                                                <Text variant="headingMd" as="h6" tone='subdued' fontWeight='medium'>
                                                    {t("Save Changes and Import products in the sales channel app")}
                                                </Text>
                                            </InlineStack>
                                        </BlockStack>
                                    </BlockStack>
                                    <ButtonGroup>
                                        <Button icon={PhoneMajor} onClick={() => props.history('../panel/support', {
                                            replace: false,
                                            state: { fromPricingPlan: true }
                                        })}>
                                            {t("Contact Us")}
                                        </Button>
                                        <Button variant={"primary"} onClick={() => appBridgeRedirect(`https://admin.shopify.com/store/${props.di.globalState.get('shop')?.replace('.myshopify.com', "")}/products?selectedView=all`, props)}>{t("Prioritise products on Shopify")}</Button>
                                    </ButtonGroup>
                                </BlockStack>
                            </BlockStack>
                        </Layout.Section>
                        <Layout.Section variant='oneThird'>
                            <img className="Custom__Image--Section" src={Beauty} />
                        </Layout.Section>
                    </Layout>
                    <Bleed marginInline="500">
                        <Divider />
                    </Bleed>
                    <InlineStack gap="200" blockAlign='center'>
                        <StepIcon />
                        <Text variant="headingSm" as="h6">
                            {t("STEP BY STEP PROCESS")}
                        </Text>
                    </InlineStack>
                    <BlockStack gap="500">
                        <Grid columns={{ xs: 1, sm: 1, md: 2, lg: 2, xl: 2 }}>
                            <Grid.Cell columnSpan={{ xs: 1, sm: 1, md: 1, lg: 1, xl: 1 }}>
                                <BlockStack gap="400">
                                    <BlockStack gap="100">
                                        <Text variant="headingXl" as="h3" fontWeight='bold'>
                                            {t("Step")} 1
                                        </Text>
                                        <Text variant="headingLg" as="h5">
                                            {t("Navigate to Products page on Shopify")}
                                        </Text>
                                    </BlockStack>
                                    <BlockStack gap="200">
                                        <InlineStack gap="200" blockAlign='start' wrap={false}>
                                            <Text variant="headingMd" as="h6" tone='subdued' fontWeight='medium'>
                                                1.
                                            </Text>
                                            <Text variant="headingMd" as="h6" tone='subdued' fontWeight='medium'>
                                                {t("From your Shopify admin, go to the 'Products' section.")}
                                            </Text>
                                        </InlineStack>
                                        <InlineStack gap="200" blockAlign='start' wrap={false}>
                                            <Text variant="headingMd" as="h6" tone='subdued' fontWeight='medium'>
                                                2.
                                            </Text>
                                            <Text variant="headingMd" as="h6" tone='subdued' fontWeight='medium'>
                                                {t("Within the 'Products' section, select the products you want to list on Amazon. You can do this by checking the boxes next to the products you wish to include.")}
                                            </Text>
                                        </InlineStack>
                                        <InlineStack gap="200" blockAlign='start' wrap={false}>
                                            <Text variant="headingMd" as="h6" tone='subdued' fontWeight='medium'>
                                                3.
                                            </Text>
                                            <Text variant="headingMd" as="h6" tone='subdued' fontWeight='medium'>
                                                {t("Once you've selected your products, click on the 'Bulk Edit' on the actions tab highlighted in the below.")}
                                            </Text>
                                        </InlineStack>
                                    </BlockStack>
                                </BlockStack>
                            </Grid.Cell>
                            <Grid.Cell columnSpan={{ xs: 1, sm: 1, md: 1, lg: 1, xl: 1 }}>
                                <img className="Custom__Image--Section" src={BulkEdit} />
                            </Grid.Cell>
                        </Grid>
                        <Divider />
                        <Grid columns={{ xs: 1, sm: 1, md: 2, lg: 2, xl: 2 }}>
                            <Grid.Cell columnSpan={{ xs: 1, sm: 1, md: 1, lg: 1, xl: 1 }}>
                                <BlockStack gap="400">
                                    <BlockStack gap="100">
                                        <Text variant="headingXl" as="h3" fontWeight='bold'>
                                            {t("Step")} 2
                                        </Text>
                                        <Text variant="headingLg" as="h5">
                                            {t("Enable or Disable the CedCommerce Amazon Channel application")}
                                        </Text>
                                    </BlockStack>
                                    <BlockStack gap="200">
                                        <InlineStack gap="200" blockAlign='start' wrap={false}>
                                            <Text variant="headingMd" as="h6" tone='subdued' fontWeight='medium'>
                                                1.
                                            </Text>
                                            <Text variant="headingMd" as="h6" tone='subdued' fontWeight='medium'>
                                                {t("In the Bulk Edit mode, locate the 'CedCommerce Amazon Channel' option in the column dropdown.")}
                                            </Text>
                                        </InlineStack>
                                        <InlineStack gap="200" blockAlign='start' wrap={false}>
                                            <Text variant="headingMd" as="h6" tone='subdued' fontWeight='medium'>
                                                2.
                                            </Text>
                                            <Text variant="headingMd" as="h6" tone='subdued' fontWeight='medium'>
                                                {t("This is where you can enable or disable the channel for individual products.")}
                                            </Text>
                                        </InlineStack>
                                        <InlineStack gap="200" blockAlign='start' wrap={false}>
                                            <Text variant="headingMd" as="h6" tone='subdued' fontWeight='medium'>
                                                3.
                                            </Text>
                                            <Text variant="headingMd" as="h6" tone='subdued' fontWeight='medium'>
                                                {t("Toggle it on for the products you want to list on Amazon and off for those you want to keep exclusive to your Shopify store.")}
                                            </Text>
                                        </InlineStack>
                                    </BlockStack>
                                </BlockStack>
                            </Grid.Cell>
                            <Grid.Cell columnSpan={{ xs: 1, sm: 1, md: 1, lg: 1, xl: 1 }}>
                                <img className="Custom__Image--Section" src={ProductSection} />
                            </Grid.Cell>
                        </Grid>
                        <Divider />
                        <BlockStack gap="800">
                            <BlockStack gap="400">
                                <BlockStack gap="100">
                                    <Text variant="headingXl" as="h3" fontWeight='bold'>
                                        {t("Step")} 3
                                    </Text>
                                    <Text variant="headingLg" as="h5">
                                        {t("Save Changes and Import products in the sales channel app")}
                                    </Text>
                                </BlockStack>
                                <BlockStack gap="200">
                                    <InlineStack gap="200" blockAlign='start' wrap={false}>
                                        <Text variant="headingMd" as="h6" tone='subdued' fontWeight='medium'>
                                            1.
                                        </Text>
                                        <Text variant="headingMd" as="h6" tone='subdued' fontWeight='medium'>
                                            {t("After making your selections, be sure to click 'Save' to apply the changes you've made.")}
                                        </Text>
                                    </InlineStack>
                                    <InlineStack gap="200" blockAlign='start' wrap={false}>
                                        <Text variant="headingMd" as="h6" tone='subdued' fontWeight='medium'>
                                            2.
                                        </Text>
                                        <Text variant="headingMd" as="h6" tone='subdued' fontWeight='medium'>
                                            {t("Come back to this page and proceed to importing products within app.")}
                                        </Text>
                                    </InlineStack>
                                </BlockStack>
                            </BlockStack>
                            <InlineStack align='end'>
                                <BlockStack gap='300' inlineAlign='end'>
                                    <Button id='proceedImporting' loading={loader} onClick={() => choosePlan()}>{t("Proceed with importing")}</Button>
                                    {
                                        !continueWithImport && <InlineError fieldID='proceedImporting' message="Kindly manage products before proceeding" />
                                    }
                                </BlockStack>
                            </InlineStack>
                        </BlockStack>
                    </BlockStack>
                </BlockStack>
            </Card>
        </Page>
    );
}

export default DI(PricingDetail);